import { useState } from 'react';
import StatusBadge from '../components/StatusBadge';
import { Bouton, BoutonTheme, Groupe, Icone } from '../components/ui';
import useBreakpoint from '../utils/useBreakpoint';
import {
  AMBRE, AMBRE_BG, AMBRE_FG, FOND_APP, RAYON_GROUPE, SEPARATEUR, TEXTE, TEXTE_MUET, TEXTE_SECONDAIRE, VERT,
} from '../theme';

/**
 * Connexion : une seule colonne centrée, quel que soit le palier — le logo, un titre, deux champs
 * réunis dans un même groupe, un bouton. Rien d'autre ne réclame l'attention de l'opérateur.
 */
export default function ConnexionScreen({ onConnecter, erreur, enLigne }) {
  const [identifiant, setIdentifiant] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [enCours, setEnCours] = useState(false);
  const { compact } = useBreakpoint();

  async function soumettre(e) {
    e.preventDefault();
    if (!identifiant || !motDePasse || enCours) return;
    setEnCours(true);
    await onConnecter(identifiant, motDePasse);
    setEnCours(false);
  }

  const styleChamp = {
    height: 58, width: '100%', padding: '0 18px', fontSize: 18,
    border: 'none', outline: 'none', background: 'transparent', color: TEXTE,
  };

  const pret = identifiant && motDePasse && !enCours;

  return (
    <div
      style={{
        minHeight: '100dvh', overflow: 'auto', background: FOND_APP, color: TEXTE,
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        padding: compact ? '40px 20px' : '56px 24px', position: 'relative',
      }}
    >
      <div style={{ position: 'absolute', top: compact ? 14 : 20, right: compact ? 14 : 20 }}>
        <BoutonTheme />
      </div>
      <div className="aqs-feuille" style={{ width: '100%', maxWidth: 440, display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: 28 }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
          <img
            className="aqs-logo"
            src={process.env.PUBLIC_URL + '/logo-horizontal.png'}
            alt="Groupe SIP"
            style={{ height: compact ? 56 : 68, width: 'auto', maxWidth: '100%', objectFit: 'contain' }}
          />
          <h1 className="aqs-grand-titre" style={{ margin: '32px 0 0', fontSize: compact ? 30 : 34 }}>Audit Quality</h1>
          <p className="aqs-para" style={{ margin: '8px 0 0', fontSize: 17, color: TEXTE_SECONDAIRE, maxWidth: 360 }}>
            Contrôle dimensionnel en atelier — confection, délavage, finition.
          </p>
        </div>

        <form style={{ display: 'flex', flexDirection: 'column', gap: 16 }} onSubmit={soumettre}>
          <Groupe>
            <label style={{ display: 'block' }}>
              <span style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)' }}>Identifiant</span>
              <input
                type="text"
                autoComplete="username"
                autoCapitalize="none"
                autoCorrect="off"
                placeholder="Identifiant"
                value={identifiant}
                onChange={(e) => setIdentifiant(e.target.value)}
                style={styleChamp}
              />
            </label>
            <div style={{ height: 0.5, marginLeft: 18, background: SEPARATEUR }} />
            <label style={{ display: 'block' }}>
              <span style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)' }}>Mot de passe</span>
              <input
                type="password"
                autoComplete="current-password"
                placeholder="Mot de passe"
                value={motDePasse}
                onChange={(e) => setMotDePasse(e.target.value)}
                style={styleChamp}
              />
            </label>
          </Groupe>

          {erreur && (
            <div role="alert" className="aqs-apparition" style={{ background: AMBRE_BG, borderRadius: RAYON_GROUPE, padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 10 }}>
              <span style={{ color: AMBRE, display: 'inline-flex' }}><Icone.Attention taille={20} /></span>
              <span className="aqs-para" style={{ fontSize: 15, fontWeight: 500, color: AMBRE_FG, minWidth: 0 }}>{erreur}</span>
            </div>
          )}

          <Bouton
            type="submit"
            variante="plein"
            hauteur={56}
            disabled={!pret}
            style={{ width: '100%', fontSize: 18, borderRadius: 14, opacity: pret ? 1 : 0.45 }}
          >
            {enCours ? 'Connexion…' : 'Se connecter'}
          </Bouton>
        </form>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
          <StatusBadge point={enLigne ? VERT : AMBRE} texte={enLigne ? 'En ligne' : 'Hors ligne'} style={{ height: 32, fontSize: 13 }} />
          <span style={{ fontSize: 13, color: TEXTE_MUET, textAlign: 'center' }}>
            Authentification via SIP ERP · Groupe SIP · Développé par BICADEV 2026
          </span>
        </div>
      </div>
    </div>
  );
}
